/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

interface PickListFieldProps {
  value: any
  readonly?: boolean
  pickMap: {
    nameKey: string
    valueKey: string
  }
}

export const PicklistField: React.FC<PickListFieldProps> = React.memo((props) => {
  const { pickMap, value } = props;
  if (!value) {
    return null;
  }
  return (
    <div>
      {value[pickMap.valueKey]}
    </div>
  );
});
